import React from 'react'
import { useNavigate } from 'react-router-dom'
import LoadingSpinner from '../loading/loading_spinner'
import { EnterpriseSummary } from '../../clients/kyousou_api_client'
import BaseCard from './base_card'
import FavoriteButton from '../buttons/favorite_button'
import { useEnterpriseFavorite } from '../../hooks/use_enterprise_favorite'
import MatchingRateBadge from '../badges/matching_rate_badge'

interface EnterpriseCardProps {
  enterprise: EnterpriseSummary
  initialized: boolean
  disableNavigation?: boolean
}

const EnterpriseCard: React.FC<EnterpriseCardProps> = (props) => {
  const navigate = useNavigate()
  const { isFavorited, toggleFavorite } = useEnterpriseFavorite(
    props.enterprise.id,
    props.enterprise.isFavorited
  )

  if (!props.initialized) {
    return <LoadingSpinner className="my-20" />
  }

  const handleCardClick = () => {
    if (!props.disableNavigation) {
      navigate(`/enterprises/detail/${props.enterprise.id}`)
    }
  }

  return (
    <BaseCard
      onClick={handleCardClick}
      className="cursor-pointer hover:shadow-lg transition-shadow"
    >
      <div className="flex flex-col h-full">
        {/* ロゴ・社名・英語名・お気に入りボタン */}
        <div className="flex items-start gap-3 mb-2">
          <img
            src={props.enterprise.logoUrl}
            alt="企業ロゴ"
            className="w-20 h-20 rounded object-cover flex-shrink-0"
          />
          <div className="flex-1 min-w-0">
            <div className="font-bold text-base break-words">
              {props.enterprise.name}
            </div>
            {/* <div className="text-xs text-main-darkgray">
              {props.enterprise.nameEn}
            </div> */}
          </div>
          {/* お気に入りボタン */}
          <div className="flex-shrink-0">
            <FavoriteButton
              isFavorited={isFavorited}
              isOwn={props.enterprise.isOwn}
              onClick={toggleFavorite}
            />
          </div>
        </div>
        {/* マッチング率バッジ */}
        <div className="mb-2">
          <MatchingRateBadge
            matchingRate={props.enterprise.matchingRate}
            isOwn={props.enterprise.isOwn}
          />
        </div>
        {/* 業種・住所（1行目） */}
        <div className="flex flex-wrap gap-4 text-xs text-main-darkgray mb-1">
          <span className="flex items-center gap-1">
            <span className="material-icons !text-base align-middle">
              domain
            </span>
            {props.enterprise.industryParentCode?.value}
          </span>
          <span className="flex items-center gap-1">
            <span className="material-icons !text-base align-middle">
              location_on
            </span>
            {props.enterprise.address}
          </span>
        </div>
        {/* 人数・設立（2行目） */}
        <div className="flex flex-wrap gap-4 text-xs text-main-darkgray mb-1">
          {/* <span className="flex items-center gap-1">
            <span className="material-icons !text-base align-middle">
              group
            </span>
            {props.enterprise.employeeCount}
          </span> */}
          <span className="flex items-center gap-1">
            <span className="material-icons !text-base align-middle">
              calendar_today
            </span>
            {/* 設立年はAPIから取得、なければダミー */}
            {props.enterprise.establishDate
              ? props.enterprise.establishDate.slice(0, 4) + '年設立'
              : ''}
          </span>
        </div>
        {/* 説明文（3行省略） */}
        <div className="text-sm line-clamp-3">
          {props.enterprise.description}
        </div>
      </div>
    </BaseCard>
  )
}

export default EnterpriseCard
